import { __assign } from "tslib";
import React from 'react';
import ButtonBase, { ButtonTypes, SharedButtonBasePropTypes, } from './ButtonBase';
import './ButtonSecondary.scss';
var ButtonSecondary = function (props) { return (React.createElement(ButtonBase, __assign({}, props, { type: ButtonTypes.SECONDARY }))); };
ButtonSecondary.defaultProps = __assign(__assign({}, ButtonBase.defaultProps), { isOutline: true, type: ButtonTypes.SECONDARY });
ButtonSecondary.propTypes = SharedButtonBasePropTypes;
export default ButtonSecondary;
//# sourceMappingURL=ButtonSecondary.js.map